import request from '@/utils/request'
import { v2Host } from '@/config/host'

// 返回除上架字体以为的字体数据
export function convertCocosModel(data: {
  file_url: string
  mod: string
  model: string
  tpl_id: number
  preset?: 1 | 0
  textures?: string[]
  rotate?: number
}) {
  return request({
    url: `${v2Host}/common/cocos-convert`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
